import { createI18n } from 'vue-i18n';

// 多语言列表
// banner 公告等接口后端需要传对应的语言数字
// 0中文 1英语 2越南语 3泰语 4马来语 5印尼语 6葡萄牙语 7西班牙 9波兰语 10保加利亚语 11土耳其语 12日语 13韩语 14法语 15俄罗斯 16阿拉伯
// 17意大利 18南非祖鲁 19罗马尼亚语 20德语 21匈牙利 22中文繁体 23印地语 24捷克语 25希腊语 26波斯语
export const langToNum = (locale: string) => {
  let languageNum = {
    cn: 0,
    en: 1,
    vi: 2,
    th: 3,
    ms: 4,
    id: 5,
    pt: 6,
    es: 7,
    pl: 9,
    bg: 10,
    tr: 11,
    ja: 12,
    ko: 13,
    fr: 14,
    ru: 15,
    ar: 16,
    it: 17,
    zu: 18,
    ro: 19,
    de: 20,
    hu: 21,
    zh: 22,
    hi: 23,
    cs: 24,
    el: 25,
    fa: 26,
    bn: 28,
  };
  let num = languageNum[locale] !== undefined ? languageNum[locale] : 1;
  window.localStorage.setItem('languageNum', num);
  // window.localStorage.setItem('language', locale);
  return num;
};

// 配置你的货币信息
const decimal = {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

const getOptions = (currency: string, options = {}) => {
  return {
    currency: {
      style: 'currency',
      currency,
      notation: 'standard',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...options,
    },
    decimal,
  };
};

const currencyMap: { [key: string]: any } = {
  EUR: getOptions('EUR'),
  USD: getOptions('USD'),
  INR: getOptions('INR'),
  IDR: getOptions('IDR'),
  JPY: getOptions('JPY'),
  KRW: getOptions('KRW'),
  PLN: getOptions('PLN'),
  BRL: getOptions('BRL'),
  RUB: getOptions('RUB'),
  TRY: getOptions('TRY'),
  VND: getOptions('VND'),
  CNY: getOptions('CNY'),
  NGN: getOptions('NGN'),
  SAR: getOptions('SAR'),
  THB: getOptions('THB'),
  AED: getOptions('AED'),
  HKD: getOptions('HKD'),
  SGD: getOptions('SGD'),
  PKR: getOptions('PKR'),
  PEN: getOptions('PEN'),
  CLP: getOptions('CLP'),
  EGP: getOptions('EGP'),
  COP: getOptions('COP'),
  AUD: getOptions('AUD'),
  MYR: getOptions('MYR'),
  ARS: getOptions('ARS'),
  KHR: getOptions('KHR'),
  BDT: getOptions('BDT'),
  GBP: getOptions('GBP'),
  NZD: getOptions('NZD'),
  NPR: getOptions('NPR'),
  NOK: getOptions('NOK'),
  BGN: getOptions('BGN'),
  CZK: getOptions('CZK'),
  GIP: getOptions('GIP'),
  HUF: getOptions('HUF'),
  ISK: getOptions('ISK'),
  CHF: getOptions('CHF'),
  RON: getOptions('RON'),
  SEK: getOptions('SEK'),
};

export const i18n = createI18n({
  locale: 'cn',
  fallbackLocale: 'cn',
  silentTranslationWarn: true,
  globalInjection: true,
  legacy: false,
  numberFormats: {
    de: currencyMap.EUR,
    en: currencyMap.USD,
    el: currencyMap.EUR,
    es: currencyMap.EUR,
    fr: currencyMap.EUR,
    hi: currencyMap.INR,
    id: currencyMap.JPY,
    ko: currencyMap.KRW,
    ja: currencyMap.JPY,
    pl: currencyMap.PLN,
    pt: currencyMap.BRL,
    ru: currencyMap.RUB,
    tr: currencyMap.TRY,
    vi: currencyMap.VND,
    zh: currencyMap.CNY,
    fi: currencyMap.EUR,
    ar: currencyMap.SAR,
    th: currencyMap.THB,
    ae: currencyMap.AED,
    'zh-hk': currencyMap.HKD,
    sg: currencyMap.SGD,
    pk: currencyMap.PKR,
    ms: currencyMap.MYR,
    km: currencyMap.KHR,
    bn: currencyMap.BDT,
    ne: currencyMap.NPR,
    no: currencyMap.NOK,
    it: currencyMap.EUR,
    nl: currencyMap.EUR,
    be: currencyMap.EUR,
    lb: currencyMap.EUR,
    ga: currencyMap.EUR,
    at: currencyMap.EUR,
    lt: currencyMap.EUR,
    lv: currencyMap.EUR,
    et: currencyMap.EUR,
    sk: currencyMap.EUR,
    sl: currencyMap.EUR,
    gr: currencyMap.EUR,
    mt: currencyMap.EUR,
    cy: currencyMap.EUR,
    hr: currencyMap.EUR,
    ad: currencyMap.EUR,
    bg: currencyMap.BGN,
    cz: currencyMap.CZK,
    hu: currencyMap.HUF,
    is: currencyMap.ISK,
    li: currencyMap.CHF,
    mc: currencyMap.EUR,
    ro: currencyMap.RON,
    sm: currencyMap.EUR,
    se: currencyMap.SEK,
    ch: currencyMap.CHF,
    lu: currencyMap.EUR,
    cs: currencyMap.CZK,
    sv: currencyMap.SEK,
    ca: currencyMap.EUR,
    ur: currencyMap.PKR,
  },
});

// setup i18n instance with glob
export const setupI18n = async (app: any) => {
  app.use(i18n);
};

export const mb_t = (srt: string, arg2?, arg3?) => {
  if (typeof srt !== 'string') {
    return srt;
  }
  if (arg2 || arg3) {
    return i18n.global.t(srt, arg2, arg3);
  }
  return srt;
};

export const $t2en = val => {
  return { cn: 'cn', en: 'en', zh: 'cn' }[val] || 'en';
};

export async function setI18nLanguage(locale: any) {
  await loadLocaleMessages(locale);
  langToNum(locale);
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }
  document.documentElement.lang = locale;
}

export const setFullbackLocale = (locale: any) => {
  if (i18n.mode === 'legacy') {
    i18n.global.fallbackLocale = locale;
  } else {
    i18n.global.fallbackLocale.value = locale;
  }
};

async function loadLocaleMessages(locale: string) {
  try {
    console.log(locale, 'loadLocaleMessages');
    // load locale messages with dynamic import
    const messages = await import(/* webpackChunkName: "locale-[request]" */ `./lib/${locale}.ts`);

    // set locale and locale message
    i18n.global.setLocaleMessage(locale, messages.default);

    return Promise.resolve();
  } catch (error) {
    console.error('i18n load error', error);
    return Promise.resolve();
  }
}
